<template>
  <van-popup v-model="visible" position="bottom" round :style="{ height: '75%' }" @click.stop>
    <div class="item-recommend" @click.stop>
      <div class="popup-header">
        <span class="title">{{ siteName ? siteName + ' - 事项推荐' : '事项推荐' }}</span>
        <van-icon name="cross" size="20" color="#999" @click="close" />
      </div>
      
      <!-- 推荐模式切换 -->
      <div class="mode-tabs">
        <div class="mode-tab" :class="{ active: currentMode === 'hot' }" @click="currentMode = 'hot'">
          <van-icon name="fire-o" />
          <span>热门推荐</span>
        </div>
        <div class="mode-tab" :class="{ active: currentMode === 'guess' }" @click="currentMode = 'guess'">
          <van-icon name="like-o" />
          <span>猜你想办</span>
        </div>
        <div class="mode-tab" :class="{ active: currentMode === 'smart' }" @click="currentMode = 'smart'">
          <van-icon name="bulb-o" />
          <span>智能推荐</span>
        </div>
      </div>
      
      <!-- 热门推荐 -->
      <div class="content-area" v-if="currentMode === 'hot'">
        <div class="section-desc">根据办件量及收藏量综合推荐高频事项</div>
        <div class="filter-tabs">
          <div class="tab-item" :class="{ active: hotFilter === 'all' }" @click="hotFilter = 'all'">全部</div>
          <div class="tab-item" v-for="tag in handleTags" :key="tag.code" 
            :class="{ active: hotFilter === tag.code }" @click="hotFilter = tag.code">
            {{ tag.name }}
          </div>
        </div>
        <div class="item-list">
          <div class="item-card" v-for="item in filteredHotItems" :key="item.id" @click="goDetail(item)">
            <div class="item-left">
              <div class="item-name">{{ item.name }}</div>
              <div class="item-tags">
                <span class="recommend-tag" :class="item.recommend">{{ getHandleLabel(item.recommend) }}</span>
                <span class="way-tag" v-for="way in getOtherWays(item)" :key="way" :class="way">{{ getHandleLabel(way) }}</span>
              </div>
            </div>
            <div class="item-right">
              <div class="item-count">{{ item.count }}人办理</div>
              <van-icon name="arrow" color="#ccc" size="14" />
            </div>
          </div>
        </div>
      </div>
      
      <!-- 猜你想办 -->
      <div class="content-area" v-if="currentMode === 'guess'">
        <div class="section-desc">根据您收藏的事项，推荐相关政务服务</div>
        <div class="item-list" v-if="guessItems.length > 0">
          <div class="item-card" v-for="item in guessItems" :key="item.id" @click="goDetail(item)">
            <div class="item-left">
              <div class="item-name">{{ item.name }}</div>
              <div class="item-reason">{{ item.reason }}</div>
            </div>
            <div class="item-right">
              <span class="recommend-tag" :class="item.recommend">{{ getHandleLabel(item.recommend) }}</span>
              <van-icon name="arrow" color="#ccc" size="14" />
            </div>
          </div>
        </div>
        <van-empty v-else description="暂无收藏记录，收藏事项后将为您推荐" />
      </div>
      
      <!-- 智能推荐 -->
      <div class="content-area" v-if="currentMode === 'smart'">
        <div class="section-desc">选择您感兴趣的标签，为您推荐相关事项</div>
        <div class="tag-section">
          <div class="tag-title">选择兴趣标签：</div>
          <div class="tag-list">
            <span class="interest-tag" v-for="tag in interestTags" :key="tag.id" 
              :class="{ active: selectedTags.includes(tag.id) }" @click="toggleTag(tag.id)">
              {{ tag.name }}
            </span>
          </div>
        </div>
        <div class="item-list" v-if="smartItems.length > 0">
          <div class="item-card" v-for="item in smartItems" :key="item.id" @click="goDetail(item)">
            <div class="item-left">
              <div class="item-name">{{ item.name }}</div>
            </div>
            <div class="item-right">
              <van-icon name="arrow" color="#ccc" size="14" />
            </div>
          </div>
        </div>
        <van-empty v-else description="暂无相关事项" />
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Icon, Empty, Toast } from 'vant';
import { getProjectList, getInterestTags, getHandleTags, getFavoriteList } from '@/api/apis';

export default {
  name: 'ItemRecommend',
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Empty.name]: Empty
  },
  props: {
    value: { type: Boolean, default: false },
    siteId: { type: [String, Number], default: '' },
    siteName: { type: String, default: '' }
  },
  data() {
    return {
      currentMode: 'hot',
      hotFilter: 'all',
      selectedTags: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      keyword: '',        // 关键词搜索
      deptId: '',         // 部门ID
      projectType: '',    // 事项类型
      // 热门推荐数据
      hotItems: [],
      // 办理方式标签
      handleTags: [],
      // 兴趣标签
      interestTags: [],
      // 猜你想办数据
      guessItemsList: [],
      // 智能推荐数据（按标签分类）
      smartItemsData: [
        { id: 101, name: '社保缴费查询', category: '社保公积金', recommend: 'mobile', tagId: 1 },
        { id: 102, name: '公积金贷款', category: '社保公积金', recommend: 'hall', tagId: 1 },
        { id: 103, name: '养老金领取', category: '社保公积金', recommend: 'mobile', tagId: 1 },
        { id: 201, name: '身份证办理', category: '户籍身份', recommend: 'hall', tagId: 2 },
        { id: 202, name: '户口迁移', category: '户籍身份', recommend: 'hall', tagId: 2 },
        { id: 203, name: '居住证办理', category: '户籍身份', recommend: 'hall', tagId: 2 },
        { id: 301, name: '医保报销', category: '医疗健康', recommend: 'mobile', tagId: 3 },
        { id: 302, name: '健康证办理', category: '医疗健康', recommend: 'hall', tagId: 3 },
        { id: 401, name: '驾驶证换领', category: '交通出行', recommend: 'self', tagId: 4 },
        { id: 402, name: '车辆年检', category: '交通出行', recommend: 'self', tagId: 4 },
        { id: 501, name: '营业执照办理', category: '企业服务', recommend: 'pc', tagId: 5 },
        { id: 502, name: '企业注销', category: '企业服务', recommend: 'pc', tagId: 5 },
        { id: 601, name: '不动产登记', category: '不动产', recommend: 'hall', tagId: 6 },
        { id: 602, name: '房产过户', category: '不动产', recommend: 'hall', tagId: 6 },
        { id: 701, name: '婚姻登记', category: '婚育收养', recommend: 'hall', tagId: 7 },
        { id: 702, name: '生育登记', category: '婚育收养', recommend: 'mobile', tagId: 7 },
        { id: 801, name: '学历认证', category: '教育培训', recommend: 'pc', tagId: 8 },
        { id: 802, name: '职业资格查询', category: '教育培训', recommend: 'mobile', tagId: 8 },
        { id: 901, name: '个人社保查询', category: '个人', recommend: 'mobile', tagId: 9 },
        { id: 902, name: '个人公积金提取', category: '个人', recommend: 'mobile', tagId: 9 },
        { id: 903, name: '个人纳税证明', category: '个人', recommend: 'mobile', tagId: 9 },
        { id: 1001, name: '企业注册登记', category: '企业', recommend: 'pc', tagId: 10 },
        { id: 1002, name: '企业年报申报', category: '企业', recommend: 'pc', tagId: 10 },
        { id: 1003, name: '企业税务登记', category: '企业', recommend: 'pc', tagId: 10 }
      ]
    };
  },
  watch: {
    value(val) {
      if (val) {
        // 每次打开都重新加载，因为站点可能变了
        this.pageNum = 1;
        this.loadProjectList();
        // 加载办理方式标签
        if (this.handleTags.length === 0) {
          this.loadHandleTags();
        }
      }
    },
    hotFilter() {
      this.pageNum = 1;
      this.loadProjectList();
    },
    currentMode(val) {
      if (val === 'smart') {
        // 切换到智能推荐时，加载兴趣标签
        if (this.interestTags.length === 0) {
          this.loadInterestTags();
        }
        // 加载所有事项
        this.pageNum = 1;
        this.loadProjectList();
      } else if (val === 'guess') {
        // 切换到猜你想办时，加载收藏列表
        this.loadFavoriteList();
      }
    }
  },
  computed: {
    visible: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    },
    filteredHotItems() {
      return this.hotItems;
    },
    guessItems() {
      return this.guessItemsList;
    },
    smartItems() {
      // 直接返回接口数据，接口已根据classIds过滤
      return this.hotItems;
    }
  },
  methods: {
    close() { this.visible = false; },
    getHandleLabel(way) {
      const labels = { mobile: '手机办', pc: '电脑办', self: '自助办', hall: '大厅办' };
      return labels[way] || way;
    },
    getOtherWays(item) {
      return (item.handleWays || []).filter(way => way !== item.recommend);
    },
    toggleTag(tagId) {
      const index = this.selectedTags.indexOf(tagId);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tagId);
      }
      // 选择标签后重新加载
      this.pageNum = 1;
      this.loadProjectList();
    },
    goDetail(item) {
      this.close();
      this.$router.push({ name: 'GuideDetail', query: { id: item.id, name: item.name } });
    },
    // 加载事项列表
    async loadProjectList() {
      this.loading = true;
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        };
        
        // 区划编码
        if (window.config.areaCode) {
          params.areaCode = window.config.areaCode;
        }
        
        // 传入站点ID，只返回该站点关联的事项
        if (this.siteId) {
          params.siteId = String(this.siteId);
        }
        
        // 关键词搜索
        if (this.keyword) {
          params.keyword = this.keyword;
        }
        
        // 部门ID
        if (this.deptId) {
          params.deptId = this.deptId;
        }
        
        // 事项类型
        if (this.projectType) {
          params.projectType = this.projectType;
        }
        
        // 根据筛选条件添加参数（办理方式筛选）
        if (this.hotFilter && this.hotFilter !== 'all') {
          // 使用接口返回的code作为参数名
          params[this.hotFilter] = '0';
        }
        
        // 智能推荐模式下，传入兴趣标签
        if (this.currentMode === 'smart' && this.selectedTags.length > 0) {
          params.classIds = this.selectedTags.join(',');
        }
        
        const res = await getProjectList(params);
        if (res.data && res.data.success && res.data.obj) {
          const list = res.data.obj.list || res.data.obj || [];
          // 映射接口字段
          this.hotItems = list.map(item => ({
            id: item.projectId || item.id,
            name: item.projectName || item.name,
            recommend: this.getRecommendWay(item),
            handleWays: this.getHandleWays(item),
            count: item.favoriteCount || item.count || 0,
            category: item.className || item.category || ''
          }));
        } else {
          this.hotItems = [];
        }
      } catch (error) {
        console.error('获取事项列表失败:', error);
        Toast.fail('获取事项列表失败');
        this.hotItems = [];
      } finally {
        this.loading = false;
      }
    },
    // 根据接口返回的字段判断推荐办理方式（tagXxx: 0显示 1不显示）
    getRecommendWay(item) {
      if (item.tagApp === 0 || item.tagApp === '0') return 'mobile';
      if (item.tagNet === 0 || item.tagNet === '0') return 'pc';
      if (item.tagAgm === 0 || item.tagAgm === '0') return 'self';
      if (item.tagWindow === 0 || item.tagWindow === '0') return 'hall';
      return 'hall';
    },
    // 获取所有支持的办理方式（tagXxx: 0显示 1不显示）
    getHandleWays(item) {
      const ways = [];
      if (item.tagApp === 0 || item.tagApp === '0') ways.push('mobile');
      if (item.tagNet === 0 || item.tagNet === '0') ways.push('pc');
      if (item.tagAgm === 0 || item.tagAgm === '0') ways.push('self');
      if (item.tagWindow === 0 || item.tagWindow === '0') ways.push('hall');
      return ways.length > 0 ? ways : ['hall'];
    },
    // 加载兴趣标签
    async loadInterestTags() {
      try {
        const res = await getInterestTags();
        if (res.data && res.data.success && res.data.obj) {
          const list = res.data.obj || [];
          // 映射接口字段
          this.interestTags = list.map(item => ({
            id: item.classId,
            name: item.className
          }));
        }
      } catch (error) {
        console.error('获取兴趣标签失败:', error);
      }
    },
    // 加载办理方式标签
    async loadHandleTags() {
      try {
        const res = await getHandleTags();
        if (res.data && res.data.success && res.data.obj) {
          const list = res.data.obj || [];
          // 映射接口字段：code对应筛选值，name对应显示名称
          this.handleTags = list.map(item => ({
            code: item.code,
            name: item.name,
            field: item.field
          }));
        }
      } catch (error) {
        console.error('获取办理方式标签失败:', error);
      }
    },
    // 加载收藏列表（猜你想办）
    async loadFavoriteList() {
      this.loading = true;
      try {
        const userId = window.config?.userId || localStorage.getItem('userId') || '';
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        };
        if (userId) {
          params.userId = userId;
        }
        const res = await getFavoriteList(params);
        if (res.data && res.data.success && res.data.obj) {
          const list = res.data.obj.list || res.data.obj || [];
          this.guessItemsList = list.map(item => ({
            id: item.projectId || item.id,
            name: item.projectName || item.name,
            recommend: this.getRecommendWay(item),
            reason: '基于您的收藏推荐',
            favoriteTime: item.favoriteTime
          }));
        } else {
          this.guessItemsList = [];
        }
      } catch (error) {
        console.error('获取收藏列表失败:', error);
        this.guessItemsList = [];
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.item-recommend {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
  
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
}

.mode-tabs {
  display: flex;
  background: #fff;
  padding: 12px 16px;
  gap: 12px;
  
  .mode-tab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 10px 0;
    border-radius: 8px;
    background: #f5f5f5;
    color: #666;
    font-size: 14px;
    transition: all 0.3s;
    
    &.active {
      background: #1989fa;
      color: #fff;
    }
  }
}

.content-area {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  padding-bottom: 70px;  // 避免被底部导航遮挡
}

.section-desc {
  font-size: 13px;
  color: #999;
  margin-bottom: 12px;
  padding: 0 4px;
}

.filter-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  
  .tab-item {
    padding: 6px 14px;
    border-radius: 16px;
    background: #fff;
    color: #666;
    font-size: 13px;
    border: 1px solid #eee;
    
    &.active {
      background: #e8f4ff;
      color: #1989fa;
      border-color: #1989fa;
    }
  }
}

.item-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.item-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
  background: #fff;
  border-radius: 8px;
  
  .item-left {
    flex: 1;
    min-width: 0;
    
    .item-name {
      font-size: 15px;
      color: #333;
      font-weight: 500;
      margin-bottom: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    
    .item-tags {
      display: flex;
      gap: 6px;
      flex-wrap: wrap;
    }
    
    .item-reason {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
    }
  }
  
  .item-right {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 12px;
    
    .item-count {
      font-size: 12px;
      color: #999;
    }
  }
}

.recommend-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  color: #fff;
  
  &.mobile { background: #07c160; }
  &.pc { background: #1989fa; }
  &.self { background: #ff976a; }
  &.hall { background: #ee0a24; }
}

.way-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  background: transparent;
  
  &.mobile { color: #07c160; border: 1px solid #07c160; }
  &.pc { color: #1989fa; border: 1px solid #1989fa; }
  &.self { color: #ff976a; border: 1px solid #ff976a; }
  &.hall { color: #ee0a24; border: 1px solid #ee0a24; }
}

.category-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  background: #f0f0f0;
  color: #666;
}

.tag-section {
  background: #fff;
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 12px;
  
  .tag-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
  }
  
  .tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
}

.interest-tag {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  background: #f5f5f5;
  color: #666;
  border: 1px solid transparent;
  transition: all 0.3s;
  
  &.active {
    background: #e8f4ff;
    color: #1989fa;
    border-color: #1989fa;
  }
}

.empty-tip {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 40px 0;
}
</style>
